module.exports = __webpack_public_path__ + "assets/img/userHead.7a745201.png";